import React from 'react';

import Navbar       from './components/Navbar';
import Hero         from './components/Hero';
import About        from './components/About';
import Services     from './components/Services';
import Countries    from './components/Countries';
import Requirements from './components/Requirements';
import Testimonials from './components/Testimonials';
import FAQ          from './components/FAQ';
import Contact      from './components/Contact';
import Footer       from './components/Footer';
import FloatingButtons from './components/FloatingButtons';

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Countries />
        <Requirements />
        <FAQ />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </>
  );
}
